module.exports = ".form-text-area ::ng-deep textarea{overflow:hidden;min-height:75px}\n"